var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIndividualIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.25724 12.0299C8.68424 11.9232 9.13082 12.1082 9.35727 12.4856C9.89516 13.3821 10.9104 13.8751 11.9998 13.8751C13.0891 13.8751 14.1044 13.3821 14.6423 12.4856C14.8687 12.1082 15.3153 11.9232 15.7423 12.0299C16.931 12.3271 18.1941 13.0444 19.2833 13.9975C20.3776 14.955 21.3586 16.2046 21.9283 17.6287C22.1334 18.1415 21.884 18.7234 21.3712 18.9286C20.8584 19.1337 20.2764 18.8843 20.0713 18.3715C19.6409 17.2956 18.872 16.2951 17.9663 15.5027C17.2773 14.8998 16.5448 14.4482 15.8777 14.1762C14.879 15.3272 13.4126 15.8751 11.9998 15.8751C10.587 15.8751 9.12051 15.3272 8.12183 14.1762C7.45472 14.4482 6.72222 14.8998 6.03328 15.5027C5.1276 16.2951 4.35861 17.2956 3.92825 18.3715C3.72314 18.8843 3.14117 19.1337 2.62839 18.9286C2.1156 18.7234 1.86619 18.1415 2.0713 17.6287C2.64094 16.2046 3.62196 14.955 4.71627 13.9975C5.80549 13.0444 7.06856 12.3271 8.25724 12.0299Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 4.81738C10.7946 4.81738 9.81738 5.79457 9.81738 7C9.81738 8.20543 10.7946 9.18262 12 9.18262C13.2054 9.18262 14.1826 8.20543 14.1826 7C14.1826 5.79457 13.2054 4.81738 12 4.81738ZM7.81738 7C7.81738 4.69 9.69 2.81738 12 2.81738C14.31 2.81738 16.1826 4.69 16.1826 7C16.1826 9.31 14.31 11.1826 12 11.1826C9.69 11.1826 7.81738 9.31 7.81738 7Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndividualIcon);
export default __webpack_public_path__ + "static/media/IndividualIcon.09927364636c6f0cdf2f31bdda0fb29e.svg";
export { ForwardRef as ReactComponent };